<template>
    <div class="c-o-my-pages-section c-o-my-pages-section--bg-gray">
        <div class="c-o-my-pages-section__inner o-wysiwyg u-margin-bottom-1">
            <div class="c-o-my-pages-section__message" v-if="errorMessages.length > 0">
                <message type="error">
                    <div class="o-wysiwyg">
                        <ul>
                            <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
                        </ul>
                    </div>
                </message>
            </div>
            <h2 class="c-o-my-pages-section__heading">Lösenord</h2>
            <p>Vill du uppdatera ditt lösenord kan du göra det här.</p>
            <router-link class="c-o-my-pages-section-link" to="/logga-in/glomt-losenordet">Jag har glömt mitt nuvarande lösenord</router-link>
        </div>
        <div class="c-o-my-pages-section__inner">
            <div class="c-o-my-pages-section__form">
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--push"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.oldPassword}"
                >
                    <input-password
                        :icon="'key'"
                        :id="4865"
                        v-model="oldPassword"
                        :name="'current-password'"
                        :label="'Lösenord'"
                        :placeholder="'Ange ditt lösenord'"
                        :invalid="errors.oldPassword">
                    </input-password>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.newPassword}"
                >
                    <input-password
                        v-model="newPassword"
                        :icon="'key'"
                        :id="4866"
                        :name="'new-password'"
                        :label="'Nytt lösenord (minst 8 tecken)'"
                        :placeholder="'Ange ditt nya lösenord'"
                        :invalid="errors.newPassword"
                        :minLength="8"
                        :maxLength="50">
                    </input-password>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation': errors.repeatPassword}"
                >
                    <input-password
                        :icon="'key'"
                        :id="4867"
                        v-model="repeatPassword"
                        :name="'repeat-new-password'"
                        :label="'Upprepa Lösenord'"
                        :placeholder="'Upprepa ditt nya lösenord'"
                        :invalid="errors.repeatPassword"
                        :minLength="8"
                        :maxLength="50">
                    </input-password>
                </div>
            </div>
            <div class="c-o-my-pages-section__save-button">
                <success-button :currentState="saveState" @buttonClicked="save"></success-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    import {
        SAVE_COMPANY_USER_PASSWORD,
        GET_SAVE_ERROR,
    } from '../../../../../../store/store-models/my-pages-company-model';
    import { timeout } from '../../../../../../helpers';
    import { setErrors, hasErrors } from '../../../../../../helpers/error-validation';

    import InputPassword from '../../../../atoms/form/AtomInputPassword.vue'
    import SuccessButton from '../../../../atoms/AtomSuccessButton.vue'
    import Message from '../../../../molecules/MoleculeMessage.vue'


    export default {
        props: [
            'userInfo'
        ],
        components:{
            SuccessButton,
            InputPassword,
            Message
        },
        data() {
            return {
                errorMessages: [],
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
                errors: {
                    oldPassword: false,
                    newPassword: false,
                    repeatPassword: false,
                },
                saveState: 'default'
            }
        },
        computed: {
            saveError: function() {
                return this.$store.getters[GET_SAVE_ERROR]('password');
            }
        },
        methods: {
            ...mapActions({
                saveUserPassword: SAVE_COMPANY_USER_PASSWORD
            }),
            async save() {
                this.errorMessages = [];
                setErrors(this.errors, ['oldPassword', 'newPassword', 'repeatPassword'], false);

                if(!this.oldPassword || !this.newPassword || !this.repeatPassword ) {
                    ['oldPassword', 'newPassword', 'repeatPassword'].forEach(model => {
                        const value = !this[model] ? true : false;
                        setErrors(this.errors, [model], value);
                    });

                    this.errorMessages.push('Fyll i alla fält');
                }

                if( this.newPassword !== this.repeatPassword ) {
                    this.errorMessages.push('Lösenorden matchar inte');
                    setErrors(this.errors, ['newPassword', 'repeatPassword'], true);
                }

                if( hasErrors(this.errors, ['oldPassword', 'newPassword', 'repeatPassword']) ) {
                    this.saveState = 'error';
                    return;
                }

                let data = {
                    'OldPassword': this.oldPassword,
                    'NewPassword': this.newPassword,
                };

                this.saveState = 'processing';

                try {
                    await this.saveUserPassword(data);
                    this.saveState = 'success';
                } catch(e) {
                    this.saveState = 'error';
                    
                    const msg = JSON.parse(e.message);
                    switch(msg.Message) {
                        case "Password incorrect":
                            setErrors(this.errors, ['oldPassword'], true);
                            this.errorMessages.push ('Du har angivit fel lösenord.');
                            break;

                        case "The request is invalid.":
                            setErrors(this.errors, ['newPassword', 'repeatPassword'], true);
                            this.errorMessages.push('Ditt nya lösenord måste vara minst 8 tecken.');
                            break;

                        default:
                            this.errorMessages.push('Något gick fel. Försök igen');
                            break;
                    };
                }

                await timeout();
                this.saveState = 'default';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountPassword.vue